import axios from "axios";
import { shopAPIUrl } from "utils/constants";

const axiosInstance = axios.create({
    baseURL: shopAPIUrl,
});

const convertToEventIDFormat = (contentName) => contentName.replace(/\s+/g, "_");

export const sendMetaEvent = (eventName, origin = "", parameters = {}, options = {}) => {
    const { content_name } = parameters;
    const dateNow = eventName === "Lead" ? Date.now() / 1000 : Date.now();
    const eventId = `OGR_${dateNow}_${eventName}${content_name !== "" ? `_${convertToEventIDFormat(content_name)}` : ""}`;

    window?.fbq && window.fbq('track', eventName, parameters, { eventID: eventId, ...options });
    axiosInstance.post('/sendEvent', { eventName, eventId, origin, ...parameters, ...options });
}

export const sendDataLayerEvent = (eventName, ecommerceData) => {
    const urlParams = new URLSearchParams(window.location.search);
    const gtmDebugParam = urlParams.get('gtm_debug') === 'true';

    if (gtmDebugParam) {
        sessionStorage.setItem('gtm_debug', true);
    }

    const isGtmDebugging = sessionStorage.getItem('gtm_debug');

    if (window && window?.dataLayer && eventName && isGtmDebugging) {
        window.dataLayer.push({
            event: eventName,
            ecommerce: {
                currency: 'GBP',
                ...ecommerceData,
            }
        });  
    }
}

